var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgStars1 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204.935,
    height: 108.895,
    viewBox: "0 0 204.935 108.895",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1680.017 -6228.847)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1488.381,6269.4l.743,2.931-2.929.743a3.021,3.021,0,0,0-2.187,3.671,3.024,3.024,0,0,0,3.672,2.189l2.929-.742.742,2.928a3.024,3.024,0,0,0,3.674,2.187,3.021,3.021,0,0,0,2.186-3.672l-.742-2.929,2.931-.742a3.024,3.024,0,0,0,2.186-3.674,3.022,3.022,0,0,0-3.671-2.187l-2.931.743-.743-2.931a3.022,3.022,0,0,0-3.671-2.187,3.025,3.025,0,0,0-2.189,3.672Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1518.259,6323.741l.743,2.931-2.932.743a3.022,3.022,0,0,0-2.186,3.671,3.024,3.024,0,0,0,3.672,2.189l2.931-.743.742,2.929a3.021,3.021,0,0,0,3.671,2.187,3.023,3.023,0,0,0,2.189-3.672l-.742-2.929,2.929-.742a3.024,3.024,0,0,0,2.186-3.674,3.021,3.021,0,0,0-3.671-2.187l-2.929.743-.743-2.931a3.025,3.025,0,0,0-3.674-2.187,3.023,3.023,0,0,0-2.186,3.672Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1662.346,6235.5a3.023,3.023,0,0,0-3.672-2.189l-2.929.743-.742-2.929a3.022,3.022,0,0,0-3.673-2.186,3.02,3.02,0,0,0-2.187,3.671l.742,2.929-2.931.743a3.023,3.023,0,0,0-2.186,3.673,3.021,3.021,0,0,0,3.671,2.187l2.931-.743.743,2.931a3.022,3.022,0,0,0,3.672,2.187,3.024,3.024,0,0,0,2.188-3.672l-.742-2.931,2.928-.742a3.021,3.021,0,0,0,2.187-3.672Zm0,0"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStars1, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/stars-1.be1789cb.svg";
export { ForwardRef as ReactComponent };